export default __webpack_public_path__ + "static/media/gallery_05.7f6af750.jpg";